module.exports = __webpack_public_path__ + "static/media/namibia-flag-round-small.ed1c8b81.jpg";